import { styleProvider } from 'libs/ng-common-lib/src/utilities/style-provider';

export const M010C060PriceStyleToyota: M010C060PriceStyleData = {
    wrapper: '',
    div: {
        container: 'min-h-75 relative',
        containerSecond: 'min-h-75 relative flex-grow gap-5 w-full ',
        dark: 'bg-dark-bg',
        notDark: 'bg-light-bg',
    },
    container: 'min-h-75 relative flex-grow w-full',
    firstPrice: {
        div: 'pl-lg -mb-4',
        dark: 'text-dark-text',
        notDark: 'text-light-text',
        price: {
            label: 'font-semibold text-12 leading-18 -mb-sm',
            value: 'font-semibold text-24',
            size: 'leading-36 m010-c060-price-xxs',
            lastPriceLabel: 'font-semibold text-12 leading-18 -mb-sm',
        },
        icon: {
            container: 'mr-md',
            size: 'w-40 h-40 min-w-40',
            dark: 'fill-dark-text',
            notDark: 'fill-light-text',
        },
        newPrice: {
            label: 'text-12 leading-18 -mt-xs whitespace-nowrap',
            value: 'font-semibold',
        },
    },
    divider: {
        dark: 'bg-light-text-accent',
        notDark: 'bg-grey-200',
        baseLarge: 'w-1 h-40',
        baseDefault: 'w-1 h-40',
    },
    secondPrice: {
        div: 'pl-lg pr-xs',
        dark: 'text-dark-text',
        notDark: 'text-light-text',
        price: {
            label: 'font-semibold text-12 leading-18 -mb-sm',
            value: 'font-semibold text-24 whitespace-nowrap',
            size: 'leading-36 m010-c060-price-xxs',
            lastPriceLabel: 'font-semibold text-12 leading-18',
        },
        lastPriceText: {
            label: 'font-semibold text-12 leading-18 -mb-sm',
        },
        leasingPrice: {
            label: 'font-semibold text-24 whitespace-nowrap',
            value: 'font-semibold text-12 leading-18 -mt-xs',
            dark: 'text-dark-text',
            notDark: 'text-light-text',
            monthly: 'font-semibold text-12 leading-18',
        },
        icon: {
            container: 'mr-md',
            size: 'w-40 h-40',
            dark: 'fill-dark-text',
            notDark: 'fill-light-text',
        },
    },
    arrow: {
        dark: 'bg-arrowRightWhite',
        notDark: 'bg-arrowRightWhite',
    },
};

export const M010C060PriceStyleOpel: M010C060PriceStyleData = {
    wrapper: '',
    div: {
        container: 'min-h-75',
        containerSecond: 'min-h-75 relative flex-grow gap-5 w-full ',
        dark: 'bg-accent',
        notDark:
            'border-t-1 border-t-grey-100 relative overflow-hidden before:empty-content before:w-100 before:h-110 before:block before:absolute before:bg-accent before:-right-48 before:-top-8 before:transform before:rotate-22',
    },
    container: 'min-h-75 relative flex-grow w-full',
    firstPrice: {
        div: 'px-16 flex-shrink',
        dark: 'text-light-text',
        notDark: 'text-light-text',
        price: {
            label: 'font-bold text-12 leading-16',
            value: 'font-bold text-24 leading-32',
            size: '',
            lastPriceLabel: 'font-light text-12 leading-16',
        },
        newPrice: {
            label: 'text-12 leading-18 -mt-4',
            value: 'font-light ',
        },
        icon: {
            container: 'mr-10',
            size: 'w-28 h-28',
            dark: 'fill-light-text',
            notDark: 'fill-light-text',
        },
    },
    divider: {
        dark: 'bg-dark-bg transform rotate-22 h-65',
        notDark: 'bg-grey-100 transform rotate-22 h-65',
        baseLarge: 'w-1 h-40 lg:mx-24',
        baseDefault: 'w-1 h-40',
    },
    secondPrice: {
        div: 'pl-21 pr-4 pt-16 pb-9',
        dark: 'text-light-text',
        notDark: 'text-light-text',
        price: {
            label: 'font-light text-12 leading-16',
            value: 'font-semibold text-24 leading-32',
            lastPriceLabel: 'font-light text-12 leading-16',
        },
        lastPriceText: {
            label: 'font-light text-12 leading-18 -mb-sm',
        },
        leasingPrice: {
            label: 'font-bold text-24 whitespace-nowrap',
            value: 'font-bold text-12 leading-18 -mt-xs',
            dark: 'text-light-text',
            notDark: 'text-light-text',
            monthly: 'font-light text-12 leading-18',
        },
        icon: {
            container: 'mr-10',
            size: 'w-28 h-28',
            dark: 'fill-light-text',
            notDark: 'fill-light-text',
        },
    },
    arrow: {
        dark: 'bg-next mr-10',
        notDark: 'bg-next mr-10',
    },
};

export const M010C060PriceStyleLexus: M010C060PriceStyleData = {
    wrapper: '',
    div: {
        container: 'px-24 pt-24 pb-40 lg:px-40 justify-between',
        containerSecond: 'relative flex-grow gap-5 w-full ',
        dark: 'bg-white',
        notDark:
            'relative overflow-hidden before:empty-content before:w-100 before:h-110 before:block before:absolute before:bg-accent before:-right-48 before:-top-8 before:transform before:rotate-22',
    },
    container: 'relative w-full',
    firstPrice: {
        div: 'flex-shrink',
        dark: 'text-light-text',
        notDark: 'text-light-text',
        price: {
            label: 'text-12 leading-18 tracking-0.5 font-book',
            value: 'text-24 leading-32 tracking-1.5',
            size: '',
            lastPriceLabel: 'text-12 leading-16 font-book',
        },
        newPrice: {
            label: 'text-12 leading-18 -mt-4',
            value: '',
        },
        icon: {
            container: 'mr-10',
            size: 'w-20 h-20',
            dark: 'fill-light-text',
            notDark: 'fill-light-text',
        },
    },
    divider: {
        dark: 'bg-grey-180 transform h-50',
        notDark: 'bg-grey-180 transform h-50',
        baseLarge: 'w-1 h-50 mx-16',
        baseDefault: 'w-1 h-50 mx-16',
    },
    secondPrice: {
        div: '',
        dark: 'text-light-text',
        notDark: 'text-light-text',
        price: {
            label: 'text-12 leading-18 tracking-0.5 font-book',
            value: 'text-24 leading-32 tracking-1.5',
            lastPriceLabel: 'font-light text-12 leading-18 font-book',
        },
        lastPriceText: {
            label: 'text-12 leading-18 -mb-sm',
        },
        leasingPrice: {
            label: 'text-24 whitespace-nowrap tracking-0.5',
            value: 'text-24 leading-32 tracking-1.5',
            dark: 'text-light-text',
            notDark: 'text-light-text',
            monthly: 'text-12 leading-18 tracking-0.5',
        },
        icon: {
            container: 'mr-10 flex-grow',
            size: 'w-20 h-20',
            dark: 'fill-light-text',
            notDark: 'fill-light-text',
        },
    },
    arrow: {
        dark: 'bg-next mr-10 shrink-0 justify-end',
        notDark: 'bg-next mr-10 shrink-0 justify-end',
    },
};

export const M010C060PriceStyleLandRover: M010C060PriceStyleData = {
    wrapper: 'm010c060 landrover',
    div: {
        container: 'px-16 py-10 justify-between',
        containerSecond: 'relative flex-grow flex-shrink',
        dark: 'bg-dark-bg text-dark-text min-h-72',
        notDark: 'bg-light-bg text-light-text',
    },
    container: 'relative flex-grow flex-shrink',
    firstPrice: {
        div: 'flex-shrink gap-4',
        dark: 'text-dark-text',
        notDark: 'text-light-text',
        price: {
            label: 'font-secondary text-11 leading-14 font-semibold',
            value: 'font-secondary',
            size: '',
            lastPriceLabel: '',
        },
        newPrice: {
            label: 'text-12 leading-18 -mt-4',
            value: 'font-secondary',
        },
        icon: {
            container: 'mr-10',
            size: 'w-25 h-20',
            dark: 'fill-dark-text',
            notDark: 'fill-light-text',
        },
    },
    divider: {
        dark: 'bg-grey-400 transform h-40',
        notDark: 'bg-grey-180 transform h-50',
        baseLarge: 'w-1 h-50 mx-10',
        baseDefault: 'w-1 h-50 mx-10',
    },
    secondPrice: {
        div: 'gap-4',
        dark: 'text-dark-text',
        notDark: 'text-light-text',
        price: {
            label: 'font-secondary text-11 leading-14 font-semibold',
            value: 'font-secondary',
            lastPriceLabel: '',
        },
        lastPriceText: {
            label: 'font-secondary text-11 leading-14 font-semibold',
        },
        leasingPrice: {
            label: 'font-secondary text-11 leading-14 font-semibold',
            value: 'font-secondary',
            dark: 'text-dark-text',
            notDark: 'text-light-text',
            monthly: 'font-normal text-11 leading-14',
        },
        icon: {
            container: 'mr-10 flex-grow',
            size: 'w-25 h-20',
            dark: 'fill-dark-text',
            notDark: 'fill-light-text',
        },
    },
    arrow: {
        dark: 'bg-next mr-10 shrink-0 justify-end',
        notDark: 'bg-nextBlack mr-10 shrink-0 justify-end',
        hideSubscriptionArrow: true,
    },
};

export const M010C060PriceStyleJaguar: M010C060PriceStyleData = {
    wrapper: '',
    div: {
        container: 'justify-between',
        containerSecond: 'relative flex-grow flex-shrink gap-5',
        dark: 'py-8 pl-16 bg-grey-400 min-h-72',
        notDark: 'py-8 pl-16 bg-light-bg  min-h-72',
    },
    container: 'relative flex-grow flex-shrink',
    firstPrice: {
        div: 'flex-shrink',
        dark: 'text-dark-text',
        notDark: 'text-light-text',
        price: {
            label: 'text-11 leading-14 font-semibold',
            value: 'text-18 leading-24 font-semibold',
            size: '',
            lastPriceLabel: 'text-12 leading-16 font-book',
        },
        newPrice: {
            label: 'text-12 leading-18 -mt-4',
            value: '',
        },
        icon: {
            container: 'mr-16',
            size: 'w-22 h-20',
            dark: 'fill-dark-text',
            notDark: 'fill-light-text',
        },
    },
    divider: {
        dark: 'bg-grey-250 transform h-50',
        notDark: 'bg-grey-250  transform h-50',
        baseLarge: 'w-1 h-50 mx-4 sm:mx-16',
        baseDefault: 'w-1 h-50 mx-4 sm:mx-16',
    },
    secondPrice: {
        div: '',
        dark: 'text-dark-text',
        notDark: 'text-light-text',
        price: {
            label: 'text-11 leading-14 font-book',
            value: 'text-11 leading-14 font-semibold',
            lastPriceLabel: 'text-11 leading-14 font-semibold',
        },
        lastPriceText: {
            label: 'text-11 leading-14 ',
        },
        leasingPrice: {
            label: 'text-18 leading-24 font-semibold',
            value: 'text-11 leading-14 font-book whitespace-nowrap',
            dark: 'text-dark-text',
            notDark: 'text-light-text',
            monthly: 'text-12 leading-18 tracking-0.5',
        },
        icon: {
            container: 'mr-16 flex-grow',
            size: 'w-22 h-20',
            dark: 'fill-dark-text',
            notDark: 'fill-light-text',
        },
    },
    arrow: {
        dark: 'bg-nextWhite mr-10 shrink-0 justify-end',
        notDark: 'bg-nextBlack mr-10 shrink-0 justify-end',
    },
};

export const M010C060PriceStyleKia: M010C060PriceStyleData = {
    wrapper: 'm010c060 kia',
    div: {
        container: 'min-h-75 py-17',
        containerSecond: ' relative flex-grow gap-5 w-full ',
        dark: 'bg-dark-bg',
        notDark:
            'border-t-1 border-t-grey-100 relative overflow-hidden before:empty-content before:w-100 before:h-110 before:block before:absolute before:bg-accent before:-right-48 before:-top-8 before:transform before:rotate-22',
    },
    container: ' relative flex-grow w-full',
    firstPrice: {
        div: 'px-16 flex-shrink gap-4',
        dark: 'text-dark-text',
        notDark: 'text-light-text',
        price: {
            label: 'font-semibold text-10 leading-17 whitespace-nowrap',
            value: 'font-semibold text-18 leading-25 whitespace-nowrap',
            size: '',
            lastPriceLabel: 'text-12 leading-16',
        },
        newPrice: {
            label: 'text-12 leading-18 -mt-4',
            value: '',
        },
        icon: {
            container: 'mr-10 flex-none',
            size: 'size-25',
            dark: 'fill-dark-text',
            notDark: 'fill-light-text',
        },
    },
    divider: {
        dark: 'bg-light-bg transform rotate-22 h-50',
        notDark: 'bg-grey-100 transform rotate-22 h-50',
        baseLarge: 'w-1 h-50 lg:mx-24',
        baseDefault: 'w-1 h-50',
    },
    secondPrice: {
        div: 'px-16 flex-shrink gap-4',
        dark: 'text-dark-text',
        notDark: 'text-light-text',
        price: {
            label: 'font-semibold text-10 leading-17 ',
            value: 'font-semibold text-18 leading-25 ',
            lastPriceLabel: 'text-12 leading-16',
        },
        lastPriceText: {
            label: 'font-semibold text-12 leading-16',
        },
        leasingPrice: {
            label: 'font-semibold text-18 leading-25 whitespace-nowrap',
            value: 'font-semibold text-18 leading-25',
            dark: 'text-dark-text',
            notDark: 'text-light-text',
            monthly: 'text-10 leading-17 font-normal',
        },
        icon: {
            container: 'mr-10 flex-none',
            size: 'size-25',
            dark: 'fill-dark-text',
            notDark: 'fill-light-text',
        },
    },
    arrow: {
        dark: 'bg-next mr-10 flex-none',
        notDark: 'bg-next mr-10 flex-none',
    },
};

export const M010C060PriceStyleSuzuki: M010C060PriceStyleData = {
    wrapper: '',
    div: {
        container: 'min-h-75 relative',
        containerSecond: 'min-h-75 relative flex-grow gap-5 w-full ',
        dark: 'bg-accentSecondary',
        notDark: 'bg-light-bg',
    },
    container: 'min-h-75 relative flex-grow w-full',
    firstPrice: {
        div: 'pl-lg -mb-4',
        dark: 'text-dark-text',
        notDark: 'text-accentSecondary',
        price: {
            label: 'font-semibold text-12 leading-18 -mb-sm',
            value: 'font-semibold text-24',
            size: 'leading-36 m010-c060-price-xxs',
            lastPriceLabel: 'font-semibold text-12 leading-18 -mb-sm',
        },
        icon: {
            container: 'mr-md',
            size: 'w-18 h-18 min-w-18 mr-8',
            dark: 'fill-accentSecondary',
            notDark: 'fill-accentSecondary',
        },
        newPrice: {
            label: 'text-12 leading-18 -mt-xs whitespace-nowrap',
            value: 'font-semibold',
        },
    },
    divider: {
        dark: 'bg-grey-200',
        notDark: 'bg-accentSecondary',
        baseLarge: 'w-1 h-40',
        baseDefault: 'w-1 h-40',
    },
    secondPrice: {
        div: 'pl-lg pr-xs',
        dark: 'text-dark-text',
        notDark: 'text-accentSecondary',
        price: {
            label: 'font-semibold text-12 leading-18 -mb-sm',
            value: 'font-semibold text-24 whitespace-nowrap',
            size: 'leading-36 m010-c060-price-xxs',
            lastPriceLabel: 'font-semibold text-12 leading-18',
        },
        lastPriceText: {
            label: 'font-semibold text-12 leading-18 -mb-sm',
        },
        leasingPrice: {
            label: 'font-semibold text-24 whitespace-nowrap',
            value: 'font-semibold text-12 leading-18 -mt-xs',
            dark: 'text-dark-text',
            notDark: 'text-accentSecondary',
            monthly: 'font-semibold text-12 leading-18',
        },
        icon: {
            container: 'mr-md',
            size: 'w-18 h-18 min-w-18 mr-8',
            dark: 'fill-light-text',
            notDark: 'fill-accentSecondary',
        },
    },
    arrow: {
        dark: 'bg-arrowRightWhite fill-accentSecondary bg-no-repeat bg-cover',
        notDark: 'bg-arrowRightBlue fill-accentSecondary bg-no-repeat bg-cover',
    },
    alternativeDark: true,
};

export const [_, provideM010C060PriceStyleData, M010C060PriceStyleToken] =
    styleProvider<M010C060PriceStyleData>('M010C060PriceStyleToken');

export interface M010C060PriceStyleData {
    wrapper: string;
    div: {
        container: string;
        containerSecond: string;
        dark: string;
        notDark: string;
    };
    container: string;
    firstPrice: {
        div: string;
        dark: string;
        notDark: string;
        price: {
            label: string;
            value: string;
            size: string;
            lastPriceLabel: string;
        };
        icon: {
            container: string;
            size: string;
            dark: string;
            notDark: string;
        };
        newPrice: {
            label: string;
            value: string;
        };
    };
    divider: {
        dark: string;
        notDark: string;
        baseLarge: string;
        baseDefault: string;
    };
    secondPrice: {
        div: string;
        dark: string;
        notDark: string;
        price: {
            label: string;
            value: string;
            size?: string;
            lastPriceLabel: string;
        };
        icon: {
            container: string;
            size: string;
            dark: string;
            notDark: string;
        };
        lastPriceText: {
            label: string;
        };
        leasingPrice: {
            label: string;
            value: string;
            dark: string;
            notDark: string;
            monthly: string;
        };
    };
    arrow: {
        dark: string;
        notDark: string;
        hideSubscriptionArrow?: boolean;
    };
    alternativeDark?: boolean;
}
